import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero, SectionHead } from "@/components/site/Blocks";
import { CtaBand } from "@/components/site/Cta";
import { IMG } from "@/data/site";
import { LOCATIONS } from "@/data/locations";

const VALUES = [
  ["Chiarezza", "Prezzi pubblici, condizioni scritte, nessun tecnicismo inutile nelle comunicazioni."],
  ["Cura", "Ogni sito viene testato su smartphone, tablet e desktop prima della pubblicazione."],
  ["Continuità", "Restiamo il tuo riferimento anche dopo la consegna, con canoni definiti."],
  ["Correttezza", "Nessuna promessa di risultati garantiti, nessun blocco al trasferimento del tuo sito."],
];

export default function About() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Chi siamo", to: "/chi-siamo" }];
  return (
    <>
      <Seo path="/chi-siamo" title="Chi siamo — agenzia digitale italiana | STUDIO WEB NS"
        description="STUDIO WEB NS è un’agenzia digitale italiana che crea e gestisce siti web, cataloghi, CRM e social per piccole attività e professionisti in tutta Italia." jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow="Chi siamo" title="Un’agenzia digitale pensata per chi non ha tempo da perdere." intro="STUDIO WEB NS permette a piccole attività, professionisti e imprese di ottenere una presenza online professionale senza doversi occupare di sviluppo e gestione tecnica." />
      <section className="py-14 md:py-20">
        <div className="wrap grid items-center gap-14 lg:grid-cols-2">
          <img src={IMG.team} alt="Riunione di lavoro su un progetto digitale" loading="lazy" width="1400" height="930" className="aspect-[4/3] w-full rounded-3xl object-cover" />
          <div>
            <SectionHead eyebrow="Il nostro approccio" title="Accessibili nel prezzo, premium nella qualità." />
            <p className="lead-text mt-6">Lavoriamo con un metodo semplice: ascoltiamo, proponiamo una soluzione con costi scritti, realizziamo e poi restiamo al tuo fianco. Seguiamo i clienti soprattutto da remoto, il che ci permette di lavorare con attività in tutta Italia mantenendo prezzi sostenibili.</p>
            <p className="lead-text mt-4">Le sedi di Milano, Como e Monza ci permettono di incontrare su appuntamento chi preferisce un confronto di persona.</p>
          </div>
        </div>
      </section>
      <section className="bg-soft py-14 md:py-20">
        <div className="wrap">
          <SectionHead eyebrow="Valori" title="Cosa puoi aspettarti da noi" />
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map(([t, d]) => <div key={t} className="card p-7"><h3 className="font-display text-lg font-bold">{t}</h3><p className="mt-2 text-sm leading-relaxed text-slate-600">{d}</p></div>)}
          </div>
        </div>
      </section>
      <section className="py-14 md:py-20">
        <div className="wrap">
          <SectionHead eyebrow="Sedi" title="Milano, Como, Monza. E tutta Italia online." />
          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {LOCATIONS.map((l) => (
              <Link key={l.slug} to={`/${l.slug}`} className="card group p-7 transition-colors hover:border-slate-900">
                <p className="font-display text-xl font-bold">{l.city}</p>
                <p className="mt-1 text-sm text-slate-600">{l.address}</p>
                <span className="link-arrow mt-5">Scopri la sede <ArrowRight className="h-4 w-4" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
